<template>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <!-- scope.row[title.prop] -->
          <h1 class="block-title" style="margin-bottom: 20px">Logs</h1>
          <el-table :data="table.records" v-loading="tableLoading">
            <el-table-column type="expand">
              <template slot-scope="props">
                <!-- Сообщение логов отображаем ТОЛЬКО после разворачивания -->
                <EventData :value="props.row.message"></EventData>
              </template>
            </el-table-column>
            <el-table-column prop="CreatedAt" label="Date" key="CreatedAt">
              <template slot-scope="scope">
                <div :title="scope.row.CreatedAt">
                  {{ parsedDate(scope.row.CreatedAt) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="level" label="Level" key="level">
              <template slot-scope="scope">
                <el-tag type="info">{{ scope.row.level }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="asset_host" label="Asset" key="asset_host">
              <template slot-scope="scope">
                {{ scope.row.asset_host }}
              </template>
            </el-table-column>
            <el-table-column prop="atom_id" label="Atom" key="atom_id">
              <template slot-scope="scope">
                <router-link :to="{ name: 'SingleAtom', params: { id: scope.row.atom_id } }">
                  {{ scope.row.atom_id }}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column prop="task_id" label="Task" key="task_id">
              <template slot-scope="scope">
                <router-link :to="{ name: 'SingleNodeTask', params: { id: scope.row.task_id } }">
                  {{ scope.row.task_id }}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column width="50">
              <template slot-scope="scope">
                <button type="button" class="btn btn-sm btn-icon del">
                  <i class="vik vik-delete"></i>
                </button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top: 10px" background layout="prev, pager, next, sizes" :total="table.total"
            :page-sizes="[10, 100, 1000, 10000]" :page-size="pageSize" @current-change="changePage"
            @size-change="changePageSize"></el-pagination>
        </div>
      </div>
    </div>
  </template>
  <script>
  import moment from "moment";
  import EventData from "@/components/internal/EventData.vue";
  import * as utils from "@/utils.js";
  import { getLogs } from "@/api.js";
  export default {
    name: "Logs",
    components: {
      EventData,
    },
    data() {
      return {
        tableLoading: true,
        pageNum: 1,
        pageSize: 10,
        table: {
          total: 0,
          filters: [],
          records: [],
          columns: [],
        },
      };
    },
    mounted() {
      this.loadEvents();
      // this.loadRSSFeed();
    },
    methods: {
      changePage(pageNum) {
        this.pageNum = pageNum;
        this.loadEvents();
      },
      changePageSize(size) {
        this.pageSize = size;
        this.loadEvents();
      },
      parsedDate(d) {
        return moment(d, "YYYY-MM-DD HH:mm:ss ZZ z").fromNow();
      },
      loadEvents() {
        let that = this;

        // сервер принимает только page/pageSize
        let params = Object.assign(this.$route.query, { page: this.pageNum, pageSize: this.pageSize });
        getLogs(utils.objectToString(params)).then((data) => {
          that.tableLoading = false;
          if (data.error) {
            this.$notify({
              title: "Errror",
              message: data.error,
              type: "error",
            });
  
            return
          }
          that.table.records = data.records;
          that.table.total = data.total;
  
          // that.total = data.Total;
          // that.filteredEvents = data.Records;
        }).catch((err) => {
          console.log("Fetch Error :-S", err);
        });;
  
      },
      loadRSSFeed() {
        fetch("http://h1.nobbd.de/reports_rss.xml").then((res) => {
          console.log(res);
          res.text().then((data) => {
            console.log(data);
          });
        });
      },
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/pages/Logs.vue